import { persistentAtom } from "@nanostores/persistent";
import { ory } from "../services/ory/pkg/sdk";

interface UserDetails {
  first?: string;
  last?: string;
  primaryPhone?: string;
  needAssistance?: boolean;
  secondaryEmail?: string;
  dob?: string;
  profileCompletion?: string;
}

interface UserAddress {
  citizenshipCountry?: string;
  zipCode?: string;
  country?: string;
  city?: string;
}

interface UserTraits {
  email?: string;
  userDetails?: UserDetails;
  address: UserAddress;
  education?: string;
  certifications?: string;
  picture?: string;
}

interface AuthState {
  userDetails: UserDetails | null;
  picture: string;
  user: UserTraits | null;
  isAuthenticated: boolean;
}

interface LoginPayload {
  identity?: {
    traits: UserTraits;
  };
  active?: boolean;
}

const initialState: AuthState = {
  user: null,
  userDetails: null,
  isAuthenticated: false,
  picture: "",
};

export const $auth = persistentAtom<AuthState>("tat", initialState, {
  encode: JSON.stringify,
  decode: JSON.parse,
});

export const login = (payload: LoginPayload): void => {
  $auth.set({
    user: payload?.identity?.traits || null,
    userDetails: payload?.identity?.traits?.userDetails || null,
    isAuthenticated:
      payload.active || !!payload?.identity?.traits?.email || false,
    picture: payload?.identity?.traits?.picture || "",
  });
};

export const logout = async (): Promise<void> => {
  try {
    const { data } = await ory.createBrowserLogoutFlow();

    if (data.logout_token) {
      await ory.updateLogoutFlow({ token: data.logout_token });
    }

    $auth.set(initialState);
  } catch (err: unknown) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (err instanceof Error && (err as any).response?.status === 401) {
      $auth.set(initialState);
      window.location.href = "/";
      return;
    }
    console.error("Logout error:", err);
    throw err;
  }
};

export const checkSession = async () => {
  try {
    const { data } = await ory.toSession();

    $auth.set({
      isAuthenticated: Boolean(data.active),
      user: data.identity?.traits,
      userDetails: data.identity?.traits?.userDetails,
      picture: data.identity?.traits?.picture || "",
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    switch (err.response?.status) {
      case 403:
      case 422:
        window.location.href = "/login?aal=aal2";
        break;
      case 401:
        $auth.set({
          isAuthenticated: false,
          user: null,
          userDetails: null,
          picture: "",
        });
        break;
      default:
        $auth.set({
          isAuthenticated: false,
          user: null,
          userDetails: null,
          picture: "",
        });
    }
  }
};

export default $auth;
